import React from 'react';
import { connect } from 'react-redux';

import FaqComponent from '../components/app/FAQ/Faq';

import * as actions from '../actions/faq';

const FAQ = (props) => {
  return (
    <FaqComponent {...props} />
  );
};

export default connect(({ faq }) => faq, actions)(FAQ);

